module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "Dashboardpdf",
    attrs: {
      "id": "Dashboardpdf"
    }
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showDash == true) ? _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('h4', {
    staticClass: "page-title mb-1"
  }, [_vm._v("FF Client Exp Dashboard")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    staticClass: "mb-1",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.viewTypeSize
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.viewTypeSize
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getPortDischargeList.length > 0 ? _vm.getPortDischargeList : _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
        _vm.viewTypeSize();
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    staticClass: "mb-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [(_vm.TotalShippedContEXP != 0 || _vm.Tot20STDTUESTypeCount != 0 || _vm.Tot40STDTUESTypeCount != 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card mb-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOT. CONTAINERS TEUS EXP")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Execution")]), _vm._v(" "), _c('td', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('td', [_vm._v("TEUS")])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.totalExec))])]), _vm._v(" "), _c('td', [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.TotalShippedContEXP))])]), _vm._v(" "), _c('td', [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.TotalShippedContEXPTUES))])])])])])])])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOT. TYPE OF CONTAINER EXP")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                          20  = " + _vm._s(_vm.Tot20STDTypeCount) + "\n                        ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                          40  = " + _vm._s(_vm.Tot40STDTypeCount) + "\n                        ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                          LCL CONTAINERS : " + _vm._s(_vm.TotLCL_Container_TotalShippedCont) + "\n                        ")])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2 "
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL TEUS ")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('span', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("\n                          " + _vm._s(_vm.Tot20STDTypeCount) + " * 1 = " + _vm._s(_vm.Tot20STDTUESTypeCount) + "\n                        ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("\n                          " + _vm._s(_vm.Tot40STDTypeCount) + " * 2 = " + _vm._s(_vm.Tot40STDTUESTypeCount) + "\n                        ")]), _vm._v("    \n                        "), _c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.Tot20STDTUESTypeCount) + " ")]), _vm._v("+ "), _c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.Tot40STDTUESTypeCount))]), _vm._v(" =  "), _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.Tot20STDTUESTypeCount + _vm.Tot40STDTUESTypeCount))])], 1), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("\n                          LCL CONTAINERS : " + _vm._s(_vm.TotLCLTUES_Container_TotalShippedCont) + "\n                        ")])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])])]), _vm._v(" "), (_vm.totalExec != '0') ? _c('div', {
    staticClass: "col-xl-5 col-md-6 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL CONTAINER TYPE EXP MODULES")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsContainer == true) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "pie",
      "width": "530",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.topShippingLineContainerExportData > '0') ? _c('div', {
    staticClass: "col-xl-4 col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP SLINE WISE CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 7 (SHIPPING LINE Line)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tr', [_c('th', [_vm._v("SLINE")]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.topShippingLineContainerExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [(index < 7) ? _c('td', {
      staticClass: "pl-0",
      on: {
        "click": function($event) {
          _vm.getSlineClientBasedGraph(item3.shippingLine, _vm.clientIdFilter, item3.shippingId)
        }
      }
    }, [_vm._v(_vm._s(item3.shippingLine))]) : _vm._e(), _vm._v(" "), (index < 7) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item3.ContainerCount))])], 1) : _vm._e(), _vm._v(" "), (index < 7) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "danger",
        "title": '20` = ' + item3.TUESSLine_Tot20STDTypeCount + ' , 40` = ' + item3.TUESSLine_Tot40STDTypeCount
      }
    }, [_c('b', [_vm._v(_vm._s(parseInt(item3.TUESSLine_Tot20STDTypeCount) + parseInt(item3.TUESSLine_Tot40STDTypeCount)))])])], 1) : _vm._e()])
  }))]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-SLine"
    },
    model: {
      value: (_vm.slinevisible),
      callback: function($$v) {
        _vm.slinevisible = $$v
      },
      expression: "slinevisible"
    }
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('th', [_vm._v("SLINE")]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])]), _vm._v(" "), _vm._l((_vm.topShippingLineContainerExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [(index >= 7) ? _c('td', {
      staticClass: "pl-0",
      on: {
        "click": function($event) {
          _vm.getSlineClientBasedGraph(item3.shippingLine, _vm.clientIdFilter, item3.shippingId)
        }
      }
    }, [_vm._v(_vm._s(item3.shippingLine))]) : _vm._e(), _vm._v(" "), (index >= 7) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item3.ContainerCount))])], 1) : _vm._e(), _vm._v(" "), (index >= 7) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "danger",
        "title": '20` = ' + item3.TUESSLine_Tot20STDTypeCount + ' , 40` = ' + item3.TUESSLine_Tot40STDTypeCount
      }
    }, [_c('b', [_vm._v(_vm._s(parseInt(item3.TUESSLine_Tot20STDTypeCount) + parseInt(item3.TUESSLine_Tot40STDTypeCount)))])])], 1) : _vm._e()])
  })], 2)])]), _vm._v(" "), (_vm.topShippingLineContainerExportData.length > 10) ? _c('span', {
    class: _vm.slinevisible ? null : 'collapsed error',
    attrs: {
      "aria-expanded": _vm.slinevisible ? 'true' : 'false',
      "aria-controls": "collapse-SLine"
    },
    on: {
      "click": _vm.slinevisibleFun
    }
  }, [_vm._v("VIEW MORE")]) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.seriesExpSlineClientGraph[0].data.length > 0 ||
    _vm.seriesExpSlineClientGraph[1].data.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL TEUS EXP MODULES - " + _vm._s(_vm.graphshippingLine) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(
    _vm.DateRangeContexecDataCount.length > 0 && (
      _vm.seriesExpSlineClientGraph[0].data.length > 0 ||
      _vm.seriesExpSlineClientGraph[1].data.length > 0)
  ) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "bar",
      "height": "550",
      "width": "1000",
      "options": _vm.chartOptionsExpSlineClientGraph,
      "series": _vm.seriesExpSlineClientGraph
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.getSlineClinteBasedData.length > 0) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [(_vm.getSlineClinteBasedData) ? _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "shiper"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Date Range")]), _vm._v(" "), _c('th', [_vm._v("Sline")]), _vm._v(" "), _c('th', [_vm._v("Execution")]), _vm._v(" "), _c('th', [_vm._v("Containers")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getSlineClinteBasedData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.fromDate + " / " + item1.toDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.shippingLine))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.allModuleIdCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ContainerCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.alltues_count))])])
  }))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.getClinteBasedData.length > 0) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [(_vm.getClinteBasedData) ? _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "shiper"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Date Range")]), _vm._v(" "), _c('th', [_vm._v("Execution")]), _vm._v(" "), _c('th', [_vm._v("Containers")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getClinteBasedData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.fromDate + " / " + item1.toDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.allModuleIdCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ContainerCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.alltues_count))])])
  }))]) : _vm._e()])])]), _vm._v(" "), (
    _vm.seriesExpClientGraph[0].data.length > 0 ||
    _vm.seriesExpClientGraph[1].data.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL TEUS EXP MODULES - " + _vm._s(_vm.graphClinetName) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [((
    _vm.seriesExpClientGraph[0].data.length > 0 ||
    _vm.seriesExpClientGraph[1].data.length > 0)) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "bar",
      "height": "550",
      "width": "1000",
      "options": _vm.chartOptionsExpClientGraph,
      "series": _vm.seriesExpClientGraph
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.topBranchWiseContainerExportData > '0') ? _c('div', {
    staticClass: "col-xl-4 col-md-6 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP BRANCH WISE CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (BRANCH)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("BRANCH")]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])]), _vm._v(" "), _vm._l((_vm.topBranchWiseContainerExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [(index < 10) ? _c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item3.BranchWise))]) : _vm._e(), _vm._v(" "), (index < 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item3.BranchContainerCount))])], 1) : _vm._e(), _vm._v(" "), (index < 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "danger"
      }
    }, [_c('b', [_vm._v(_vm._s(item3.BranchContainerTues_Count))])])], 1) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-branchvisible"
    },
    model: {
      value: (_vm.branchvisible),
      callback: function($$v) {
        _vm.branchvisible = $$v
      },
      expression: "branchvisible"
    }
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tr', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('th', [_vm._v("BRANCH")]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.topBranchWiseContainerExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [(index >= 10) ? _c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item3.BranchWise))]) : _vm._e(), _vm._v(" "), (index >= 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item3.BranchContainerCount))])], 1) : _vm._e(), _vm._v(" "), (index >= 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "danger"
      }
    }, [_c('b', [_vm._v(_vm._s(item3.BranchContainerTues_Count))])])], 1) : _vm._e()])
  }))])]), _vm._v(" "), (_vm.topBranchWiseContainerExportData.length > 10) ? _c('span', {
    class: _vm.branchvisible ? null : 'collapsed error',
    attrs: {
      "aria-expanded": _vm.branchvisible ? 'true' : 'false',
      "aria-controls": "collapse-branchvisible"
    },
    on: {
      "click": _vm.branchvisibleFun
    }
  }, [_vm._v("VIEW MORE")]) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.top10ContainerTypeExportData.length > '0' && _vm.top10BranchesExportData.length > 0) ? _c('div', {
    staticClass: "col-xl-8 col-md-8 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP Client WISE TYPE BASED CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (Branch)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.totalHtmlCont)
    }
  }, [_vm._v("\n                        " + _vm._s(this.totalHtmlCont) + "\n                        ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.top10ContainerTypeExportData.length > '0' && _vm.top10SlinesExportData.length > 0) ? _c('div', {
    staticClass: "col-xl-8 col-md-8 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP SLINE WISE TYPE BASED CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (SLINE)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.totalSlineHtmlCont)
    }
  }, [_vm._v("\n                        " + _vm._s(this.totalSlineHtmlCont) + "\n                        ")])])])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 col-sm-12 grid-margin stretch-card mb-2 text-center"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-4 col-sm-12 grid-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xl-4 col-sm-12 grid-margin"
  }, [_c('center', [_c('h6', {
    staticClass: "card-title error text-center"
  }, [_vm._v("Data Not Found !")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-4 col-sm-12 grid-margin"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  })], 1) : _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [(_vm.showDash == false) ? _c('b-navbar-brand', [(_vm.employeeName != '') ? _c('h4', {
    staticClass: "page-title"
  }, [_vm._v("\n              Welcome "), _c('small', [_vm._v(_vm._s(_vm.employeeName))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fba722e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ffClientDashboard .vue
// module id = 2919
// module chunks = 0